export default __webpack_public_path__ + "static/media/PW.ef0f6a60.svg";